export default function resetSetItem (key, newVal) {
    let newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val);
        newStorageEvent.initStorageEvent('setItem');
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal);
}